import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import appsImage from "./assets/home/app_image.jpg";
import solution_1 from "./assets/home/solution_1.png";
import solution_2 from "./assets/home/solution_2.png";
import solution_3 from "./assets/home/solution_3.png";
import solution_4 from "./assets/home/solution_4.png";
import solution_5 from "./assets/home/solution_5.png";
import solution_6 from "./assets/home/solution_6.png";
import solution_7 from "./assets/home/solution_7.png";
import solution_8 from "./assets/home/solution_8.png";
import solution_9 from "./assets/home/solution_9.png";
import synqua from "./assets/home/synqua.png";

import openturf from "./assets/home/openturf.png";
import integra from "./assets/home/integra.jpeg";
import simpragma from "./assets/home/simpragma_logo.jpeg";
import tripture from "./assets/home/tripture_value.png";
import sakhatechglobal from "./assets/home/sakhatechglobal.png";
import comviva from "./assets/home/comviva.svg";
import techmahendra from "./assets/home/techmahendra.png";
import woodsliving from "./assets/home/woodsliving.png";
import bannerImage from "./assets/banner/banner_1.jpg";
import Footer from "./footer";

function HomeContent() {
  const appDescription =
    "We specialize in transforming your ideas into powerful digital solutions by delivering cutting-edge services across every stage of software development. Whether you need Android or iOS app development, backend systems, or full-stack solutions, our team ensures your product is fast, secure, and scalable. With expertise in DevOps, we accelerate your time-to-market through seamless deployments and cloud automation. We also integrate AI-driven features like chatbots, recommendations, predictive analytics, and natural language processing to give your applications a competitive edge. Our exceptional UI/UX design team creates intuitive, engaging user experiences that keep your customers coming back. Beyond development, we provide post-launch support, maintenance, and performance optimization to ensure long-term success. Partner with us to bring your vision to life, elevate your brand, and turn it into a market-leading product recognized for innovation and impact.";
  const aiDrivenTitle = "AI-Driven Success Through Our Unique Approach";
  const aiDrivenDescription =
    "We leverage AI-powered insights to optimize decision-making and unlock new market opportunities. Our intelligent systems ensure rapid, data-driven deliverables and real-time solutions that consistently maximize ROI.";
  const scaleTitle = "Scale Your Business with AI-Powered Innovation";
  const scaleDescription =
    "We fuel your business transformation with cutting-edge AI solutions, advanced app development, and dynamic design strategies tailored to scale your operations. From startups to Fortune 500 companies, our tailored technology services help you harness the power of AI, innovative mobile and web applications, and cloud-based solutions. Whether you are a small business or a global enterprise, we create intuitive, AI-driven applications and designs that enhance user experiences, drive growth, and maximize your ROI in a competitive market.";

  const experience = [
    {
      image: solution_1,
      title: "Web Application Development",
      description:
        "Build powerful, intuitive, SEO-optimized, and responsive web apps that strengthen your business’s online presence.",
    },
    {
      image: solution_2,
      title: "Custom Software Development",
      description:
        "Deliver tailored software solutions from concept to deployment, including design, testing, and ongoing support.",
    },
    {
      image: solution_3,
      title: "Mobile App Solutions",
      description:
        "Create efficient, secure, and innovative mobile applications that drive digital transformation across industries.",
    },
    {
      image: solution_4,
      title: "UI/UX Design Services",
      description:
        "Craft engaging, intuitive, and visually appealing designs that reflect your brand identity and resonate with your audience.",
    },
    {
      image: solution_5,
      title: "IT Management Services",
      description:
        "Provide adaptive, scalable IT solutions to manage critical infrastructure and operations with efficiency and agility.",
    },
    {
      image: solution_6,
      title: "Online Reputation Management",
      description:
        "Implement data-driven marketing strategies designed to boost leads, increase sales, and enhance your brand’s reputation.",
    },
    {
      image: solution_7,
      title: "Software Quality Testing",
      description:
        "Ensure robust software performance through functional, security, compatibility, and performance testing services.",
    },
    {
      image: solution_8,
      title: "Web Application Security",
      description:
        "Deploy smart, resilient security measures to protect your web apps from major vulnerabilities and cyber threats.",
    },
    {
      image: solution_9,
      title: "Cloud Hosting Services",
      description:
        "Offer enterprise-level cloud hosting that boosts flexibility, scalability, and performance for your digital assets.",
    },
  ];

  const partners = [
    { name: "", image: openturf },
    { name: "", image: integra },
    { name: "", image: simpragma },
    { name: "", image: tripture },
    { name: "", image: sakhatechglobal },
    { name: "", image: comviva },
    { name: "", image: techmahendra },
    { name: "", image: woodsliving },
    { name: "", image: synqua },
  ];

  return (
    <Box
      sx={{
        flexGrow: 1,
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        width: "100%",
        height: "100%",
      }}
    >
      <Box maxWidth={"100%"}>
        <Box
          sx={{
            minHeight: { xs: "50vh", md: "80vh" },
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
          }}
        >
          <Box sx={{ maxWidth: 600, mb: 4 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              Empowering Innovation with AI & Design
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          padding: { xs: 2, md: 8 },
          textAlign: "center",
        }}
      >
        <Box
          sx={{
            pl: { xs: 0, md: 15 },
            pr: { xs: 0, md: 15 },
          }}
        >
          <Typography
            variant="h3"
            gutterBottom
            sx={{
              fontSize: {
                xs: "1.8rem", // small screens (mobile)
                sm: "2.4rem", // small to medium
                md: "3rem", // medium and up
              },
            }}
          >
            {aiDrivenTitle}
          </Typography>
          <Typography
            variant="h5"
            sx={{
              fontSize: {
                xs: "1rem", // small screens
                sm: "1.25rem",
                md: "1.5rem",
              },
            }}
          >
            {aiDrivenDescription}
          </Typography>
        </Box>
      </Box>

      <Box sx={{ width: "100%", display: "flex" }}>
        <Grid
          container
          spacing={{ xs: 2, md: 4 }}
          sx={{ width: "100%", margin: 0 }}
        >
          <Grid
            item
            xs={12}
            md={6}
            size={{ xs: 12, md: 6 }}
            sx={{ pl: 4, pr: { xs: 4, md: 0 } }}
          >
            <Box
              component="img"
              src={appsImage}
              alt="AI Illustration"
              sx={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: 2,
              }}
            />
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            sx={{
              pt: { xs: 0, md: 2 },
              pr: 4,
              pl: { xs: 4, md: 0 },
              display: "flex",
              alignItems: "top",
            }}
            size={{ xs: 12, md: 6 }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: {
                  xs: "1rem",
                  sm: "1.25rem",
                  md: "1.5rem",
                },
                textAlign: "center",
              }}
            >
              {appDescription}
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box maxWidth={"100%"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: { xs: 2, md: 8 },
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              pl: { xs: 0, md: 15 },
              pr: { xs: 0, md: 15 },
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                fontSize: {
                  xs: "1.8rem", // small screens (mobile)
                  sm: "2.4rem", // small to medium
                  md: "3rem", // medium and up
                },
              }}
            >
              {scaleTitle}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xs: "1rem", // small screens
                  sm: "1.1rem",
                  md: "1.3rem",
                },
              }}
            >
              {scaleDescription}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box maxWidth={"100%"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <Box
            sx={{
              pl: { xs: 0, md: 15 },
              pr: { xs: 0, md: 15 },
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                fontSize: {
                  xs: "1.8rem", // small screens (mobile)
                  sm: "2.4rem", // small to medium
                  md: "3rem", // medium and up
                },
              }}
            >
              Our Expertise
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xs: "1rem", // small screens
                  sm: "1.25rem",
                  md: "1.5rem",
                },
              }}
            >
              Backed by a team of highly skilled professionals, we provide
              innovative IT solutions that give you a competitive advantage in
              the market.
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignContent: "center",
            justifyContent: "center",
          }}
        >
          <Grid
            container
            spacing={4}
            sx={{
              width: "100%",
              justifyContent: "center",
              textAlign: "center",
            }}
          >
            <Grid
              container
              spacing={4}
              justifyContent="center"
              sx={{ textAlign: "center" }}
            >
              {experience.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={6}
                  key={index}
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Box sx={{ maxWidth: 300, padding: 2 }}>
                    <Box
                      component="img"
                      src={item.image}
                      alt="AI Illustration"
                      sx={{
                        height: "auto",
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                    />
                    <Typography
                      variant="h3"
                      gutterBottom
                      sx={{
                        fontSize: {
                          xs: "1rem",
                          sm: "1rem",
                          md: "1rem",
                        },
                        color: "#C2185B",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography
                      variant="h3"
                      gutterBottom
                      sx={{
                        fontSize: {
                          xs: "1rem",
                          sm: "1rem",
                          md: "1rem",
                        },
                      }}
                    >
                      {item.description}
                    </Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box maxWidth={"100%"}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              pt: 2,
              pl: { xs: 3, md: 5 },
              pr: { xs: 3, md: 5 },
              pb: { xs: 3, md: 5 },
            }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                fontSize: {
                  xs: "1.8rem", // small screens (mobile)
                  sm: "2.4rem", // small to medium
                  md: "3rem", // medium and up
                },
              }}
            >
              Why Choose Linus100 as Your IT Solution Partner?
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xs: "1rem", // small screens
                  sm: "1.1rem",
                  md: "1.3rem",
                },
              }}
            >
              At Linus100, we deliver high-quality, scalable IT solutions that
              empower businesses of all sizes — from startups to global
              enterprises. Our expertise spans Android development, backend
              systems, DevOps, AI, and UI/UX design, allowing us to craft
              intuitive mobile apps, robust backend architectures, seamless
              cloud operations, and intelligent AI solutions. With a focus on
              innovation, we help companies automate processes, improve user
              experiences, and drive digital transformation across industries
              like healthcare, fintech, e-commerce, logistics, and education.
              Our agile delivery approach ensures transparency, speed, and
              measurable results at every stage.
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontSize: {
                  xs: "1rem", // small screens
                  sm: "1.1rem",
                  md: "1.3rem",
                },
                pt: 2,
              }}
            >
              But we don’t stop at product launch — we offer comprehensive
              post-development support to keep your software secure, updated,
              and aligned with evolving business goals. Whether it’s bug fixes,
              performance monitoring, or scaling for growth, our team is
              dedicated to helping you maximize ROI and stay ahead of the
              competition. With cutting-edge tools and a technology-agnostic
              mindset, Linus100 becomes more than a vendor — we become your
              long-term partner in success, committed to turning bold ideas into
              market-leading products that shape the future.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box>
        <Typography
          variant="h3"
          gutterBottom
          sx={{
            fontSize: {
              xs: "1.8rem",
              sm: "2.4rem",
              md: "3rem",
            },
            textAlign: "center",
          }}
        >
          Some of our Top Partners
        </Typography>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            width: "100%",
            p: { xs: 0, md: 0 },
            pb: { xs: 5, md: 10 },
          }}
        >
          <Grid
            container
            rowSpacing={0}
            columnSpacing={4}
            justifyContent="center"
            maxWidth="lg"
          >
            {partners.map((partner, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                key={index}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Box
                  component="img"
                  src={partner.image}
                  alt={partner.name}
                  sx={{
                    width: { xs: "80px", md: "180px" },
                    height: { xs: "80px", md: "180px" },
                    objectFit: "contain",
                    borderRadius: 2,
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
}

export default HomeContent;
